import React from 'react';
import Section from '../../../../components/Display/Section';
import Data from '../../../../components/Display/Data';
import DataTag from '../../../../components/Display/DataTag';
import { getConstant } from '../../../../utils/constants';
import MultiLineData from '../../../../components/Display/MultiLineData';
import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';
import ExternalResourceItem from '../ExternalResources/ExternalResourceItem';
import { DataView } from 'primereact/dataview';
import EventItem from '../Events/EventItem';
import MultipleDataTag from '../../../../components/Display/MultipleDataTag';

function InternalResourceDetail({
  resource,
  handleUpdateResource,
  handleDelete,
  handleUpdateExternalResource,
  handleUpdateEvent
}) {
  const updateResourceActions = [
    {
      onClick: handleUpdateResource,
      label: 'Modifier les informations',
      icon: 'pi-pencil'
    }
  ];

  const updateExternalResourceActions = [
    {
      onClick: handleUpdateExternalResource,
      label: 'Ajouter des ressources thématiques',
      icon: 'pi-pencil'
    }
  ];

  const updateEventActions = [
    {
      onClick: handleUpdateEvent,
      label: 'Ajouter des évènements',
      icon: 'pi-pencil'
    }
  ];

  const confirmDeletion = (resource) => {
    confirmDialog({
      message: 'Êtes-vous sûr de vouloir supprimer cette Ressource ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Oui',
      rejectLabel: 'Annuler',
      acceptClassName: 'bg-red-500 border-red-500',
      accept: () => handleDelete(resource)
    });
  };

  const resourceTemplate = (externalResource) => (
    <ExternalResourceItem resource={externalResource} />
  );

  const eventTemplate = (event) => <EventItem event={event} />;

  return (
    <div className={`h-full w-full flex-col flex gap-5`}>
      <Section label="Informations Générales" actions={updateResourceActions}>
        <div className="flex flex-wrap gap-5">
          <Data key="title" label={'Titre'} value={resource.title} large />
          <Data key="author" label={'Auteur'} value={resource.author} large />

          <DataTag
            key="type"
            label={'Type'}
            tag={{
              label: getConstant('solarys.resourceTypes', resource.type).label,
              icon: 'star',
              bgColor: 'bg-green-700'
            }}
            large
          />

          <DataTag
            key="city"
            label={'Ville'}
            tag={{
              label: getConstant('solarys.cities', resource.city).label,
              icon: 'location',
              bgColor: 'bg-purple-800'
            }}
            large
          />
          <div className="flex flex-wrap gap-5">
            <MultipleDataTag
              key="publilc_list"
              label={'Public Cible'}
              tags={resource.public_list.map((ot) => ({
                label: ot.label,
                bgColor: 'bg-yellow-500',
                icon: 'man'
              }))}
            />
          </div>
        </div>
        <div className="flex flex-wrap gap-5">
          <MultiLineData key="content" label={'Contenu'} value={resource.content} large asHtml />
        </div>
      </Section>
      <Section label="Ressources thématiques associées" actions={updateExternalResourceActions}>
        <DataView
          value={resource.related_resources}
          itemTemplate={resourceTemplate}
          className="pb-20"
          emptyMessage="Aucune ressource trouvée"
        />{' '}
      </Section>
      <Section label="Ressources thématiques associées" actions={updateEventActions}>
        <DataView
          value={resource.related_events}
          itemTemplate={eventTemplate}
          className="pb-20"
          emptyMessage="Aucun évènement trouvé"
        />{' '}
      </Section>
      <Section label="Autres actions">
        <div className="flex flex-row">
          <Button
            key={'delete'}
            label={"Supprimer l'évènement"}
            className="!w-54"
            outlined
            onClick={() => confirmDeletion(resource)}
            severity="danger"
          />
        </div>
      </Section>
    </div>
  );
}

export default InternalResourceDetail;
